"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
var React = require("react");
var styled_1 = require("../../styled");
var index_1 = require("../../theme/index");
var toHTMLDataTags_1 = require("../../utils/toHTMLDataTags");
var getBGColorFromProps = function (_a) {
    var variant = _a.variant, theme = _a.theme;
    return theme.buttons[variant].bg;
};
var getColorFromProps = function (_a) {
    var variant = _a.variant, theme = _a.theme;
    return theme.buttons[variant].text;
};
var getBorderColorFromProps = function (_a) {
    var variant = _a.variant, theme = _a.theme;
    return 'none';
};
var getHoverFromProps = function (_a) {
    var variant = _a.variant, theme = _a.theme;
    return theme.buttons[variant].pressed;
};
var buttonSizes = {
    small: {
        'min-width': '6.583rem',
        height: '3rem',
        'padding-left': index_1.spacing.tiny,
        'padding-right': index_1.spacing.tiny,
        'padding-top': index_1.spacing.mini,
        'padding-bottom': index_1.spacing.mini,
    },
    med: {
        'min-width': '8rem',
        height: '3.333rem',
        'padding-left': index_1.spacing.small,
        'padding-right': index_1.spacing.small,
        'padding-top': index_1.spacing.mini,
        'padding-bottom': index_1.spacing.mini,
    },
    large: {
        'min-width': '9rem',
        height: '4rem',
        'padding-left': index_1.spacing.small,
        'padding-right': index_1.spacing.small,
        'padding-top': index_1.spacing.mini,
        'padding-bottom': index_1.spacing.mini,
    },
};
var EnvirioButton = function (_a) {
    var variant = _a.variant, onClick = _a.onClick, children = _a.children, className = _a.className, disabled = _a.disabled, type = _a.type, _b = _a.style, style = _b === void 0 ? {} : _b, _c = _a.dataTags, dataTags = _c === void 0 ? {} : _c;
    return (React.createElement("button", __assign({ onClick: onClick, disabled: disabled, className: className, style: style, type: type }, toHTMLDataTags_1.toHTMLDataTags(dataTags)),
        React.createElement("span", null, children)));
};
var getSizing = function (size) {
    if (!size)
        return '';
    return "\n    min-width: " + buttonSizes[size]['min-width'] + ";\n    height: " + buttonSizes[size]['height'] + ";\n    padding-left: " + buttonSizes[size]['padding-left'] + ";\n    padding-right: " + buttonSizes[size]['padding-right'] + ";\n    padding-top: " + buttonSizes[size]['padding-top'] + ";\n    padding-bottom: " + buttonSizes[size]['padding-bottom'] + ";\n  ";
};
var getWidth = function (props) {
    if (!props.fullWidth)
        return '';
    return 'width: 100%;';
};
var BaseButton = styled_1.default(EnvirioButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  padding: 0.78571429em 1.5em 0.78571429em;\n  border: none;\n  outline: none;\n  line-height: 1em;\n  font-style: normal;\n  text-align: center;\n  border-radius: 4px;\n"], ["\n  cursor: pointer;\n  padding: 0.78571429em 1.5em 0.78571429em;\n  border: none;\n  outline: none;\n  line-height: 1em;\n  font-style: normal;\n  text-align: center;\n  border-radius: 4px;\n"])));
exports.Button = styled_1.default(BaseButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n\n  ", "\n\n  font-size: ", ";\n  font-weight: ", ";\n\n  background-color: ", ";\n\n  color: ", ";\n\n  border: ", ";\n\n  opacity: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  ", "\n\n  ", "\n\n  font-size: ", ";\n  font-weight: ", ";\n\n  background-color: ",
    ";\n\n  color: ",
    ";\n\n  border: ",
    ";\n\n  opacity: ", ";\n\n  &:hover {\n    background-color: ",
    ";\n  }\n"])), function (props) { return getSizing(props.size); }, function (props) { return getWidth(props); }, function (props) { return (props.fontSize ? props.fontSize : '1.167em'); }, function (props) { return (props.fontWeight ? props.fontWeight : '700'); }, function (props) {
    return getBGColorFromProps({
        theme: props.theme,
        variant: props.variant || 'default',
    });
}, function (props) {
    return getColorFromProps({
        theme: props.theme,
        variant: props.variant || 'default',
    });
}, function (props) {
    return getBorderColorFromProps({
        theme: props.theme,
        variant: props.variant || 'default',
    });
}, function (props) { return (props.disabled ? '0.25' : '1'); }, function (props) {
    return getHoverFromProps({
        variant: props.variant || 'default',
        theme: props.theme,
    });
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map